import { Component, Inject, OnDestroy } from "@angular/core";
import { BehaviorSubject, Observable, Subject, Subscription } from "rxjs";
import { DiscoveryService } from "../discovery.service";

@Component({
  selector: "hydra-home",
  templateUrl: "./hydra-home.component.html",
  styleUrls: ["./hydra-home.component.scss"]
})
export class HydraHomeComponent implements OnDestroy {
  public readonly isDataAvailable: Observable<boolean>;

  private readonly entryPointSubscription: Subscription;
  private readonly documentationSubscription: Subscription;
  private readonly _isDataAvailable: Subject<boolean>;

  public constructor(@Inject(DiscoveryService) private discoveryService: DiscoveryService) {
    this._isDataAvailable = new BehaviorSubject(false);
    this.isDataAvailable = this._isDataAvailable.asObservable();
    this.entryPointSubscription = this.discoveryService.documentation.subscribe(_ => this._isDataAvailable.next(!!_));
    this.documentationSubscription = this.discoveryService.resource.subscribe(_ => this._isDataAvailable.next(!!_));
  }

  public ngOnDestroy(): void {
    this.entryPointSubscription.unsubscribe();
    this.documentationSubscription.unsubscribe();
  }
}
